'use strict';

namespace PushNotification {
  export type Type = 'twilio.channel.new_message' | 'twilio.channel.added_to_channel'
    | 'twilio.channel.invited_to_channel' | 'twilio.channel.removed_from_channel';

  export interface Descriptor {
    title: string;
    body: string;
    sound: string;
    badge: number;
    action: string;
    type: PushNotification.Type;
    data: Object;
  }
}

/**
 * @classdesc Push notification representation within Chat Client
 * @property {String} [action] - Notification action (`click_action` in FCM/GCM terms and `category` in APN terms)
 * @property {Number} [badge] - Number for the badge
 * @property {String} body - Notification text
 * @property {PushNotification#ChatData} data - Additional Chat data
 * @property {String} [sound] - Notification sound
 * @property {String} [title] - Notification title
 * @property {PushNotification#NotificationType} type - Notification type
 */
class PushNotification {
  public readonly title: string;
  public readonly body: string;
  public readonly sound: string;
  public readonly badge: number;
  public readonly action: string;
  public readonly type: PushNotification.Type;
  public readonly data: Object;

  /**
   * Chat push notification type
   * @typedef {('twilio.channel.new_message' | 'twilio.channel.added_to_channel'
   | 'twilio.channel.invited_to_channel'  | 'twilio.channel.removed_from_channel')} PushNotification#NotificationType
   */

  /**
   * Additional Chat data for given Push Notification
   * @typedef {Object} PushNotification#ChatData
   * @property {String} [channelSid] - SID of Channel
   * @property {Number} [messageIndex] - Index of Message in Channel
   * @property {String} [messageSid] - SID of Message
   */

  /**
   * @param {PushNotification.Descriptor} data - initial data for PushNotification
   */
  constructor(data: PushNotification.Descriptor) {
    this.title = data.title || null;
    this.body = data.body || null;
    this.sound = data.sound || null;
    this.badge = data.badge || null;
    this.action = data.action || null;
    this.type = data.type || null;
    this.data = data.data || {};
  }

}

export { PushNotification };
